import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 80, height = 80, color = 'currentColor' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 80 80' fill='none'>
  <path
    d='M71.3665 38.6L41.3665 8.59999C40.1665 7.39999 38.4998 6.66666 36.6665 6.66666H13.3332C9.6665 6.66666 6.6665 9.66666 6.6665 13.3333V36.6667C6.6665 38.5 7.39984 40.1667 8.63317 41.4L38.6332 71.4C39.8332 72.6 41.4998 73.3333 43.3332 73.3333C45.1665 73.3333 46.8332 72.6 48.0332 71.3667L71.3665 48.0333C72.5998 46.8333 73.3332 45.1667 73.3332 43.3333C73.3332 41.5 72.5665 39.8 71.3665 38.6ZM18.3332 23.3333C15.5665 23.3333 13.3332 21.1 13.3332 18.3333C13.3332 15.5667 15.5665 13.3333 18.3332 13.3333C21.0998 13.3333 23.3332 15.5667 23.3332 18.3333C23.3332 21.1 21.0998 23.3333 18.3332 23.3333Z'
    fill='#D5D6DA'
  />
</svg>
